<template>
  <base-dialog-component
    :showClose="true"
    :open="open"
    :title="$t('productSelectionTitle')"
    optionType="product"
    :options="productsLab"
    @selectOption="selectProduct"
    @closeDialog="closeDialog"
    height="auto"
    width="50vw"
    minWidth="620px"
    top="50%"
    left="50%"
    heightBody="40px"
    :center="true"
    :overlay="true"
  ></base-dialog-component>
</template>
<script>
import baseComponent from "./baseComponent.vue";

export default {
  name: "ProductSelectionComponent",
  components: {
    baseDialogComponent: baseComponent,
  },
  data() {
    return {
      open: false,
      resolveDialog: null,
      products: {
        Chill_Lab: [
          {
            title: "productSelectionTitle_AFC_NA",
            body: "productSelectionBody_AFC_NA",
            confirm: "productSelectionConfirm_AFC_NA",
            model: "AFC_NA",
            image: require("../../assets/images/products/AFC_NA.jpg"),
          },
          {
            title: "productSelectionTitle_AFC_AD",
            body: "productSelectionBody_AFC_AD",
            confirm: "productSelectionConfirm_AFC_AD",
            model: "AFC_AD",
            image: require("../../assets/images/products/AFC_AD.jpg"),
          },
        ],
        Indoor_Lab: [
          {
            title: "productSelectionTitle_CWA",
            body: "productSelectionBody_CWA",
            confirm: "productSelectionConfirm_CWA",
            model: "CWA",
            image: require("../../assets/images/products/CWA.jpg"),
          },
          {
            title: "productSelectionTitle_PDX",
            body: "productSelectionBody_PDX",
            confirm: "productSelectionConfirm_PDX",
            model: "PDX",
            image: require("../../assets/images/products/PDX.jpg"),
          },
        ],
      },
    };
  },
  computed: {
    lab() {
      return this.$store.getters.getCurrentLab;
    },
    productsLab() {
      if (this.lab) {
        return this.products[this.lab];
      }
      return [];
    },
  },
  beforeMount() {
    this.$root.$on("openProductSelection", this.openProductSelection);
  },
  beforeDestroy() {
    this.$root.$off("openProductSelection", this.openProductSelection);
  },
  methods: {
    openProductSelection({ resolve }) {
      this.resolveDialog = resolve;
      this.open = true;
    },
    selectProduct({ option }) {
      this.resolveDialog(option);
      this.open = false;
    },
    closeDialog() {
      this.resolveDialog(false);
      this.open = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
